import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { UserStore } from '@core/stores';

export const sessionIdResolver: ResolveFn<boolean> = () => {
  const store = inject(UserStore);

  store.onGenerateSessionId();

  return true;
};
